import React, { useEffect } from 'react'
import { SvgIcon } from '@mui/material'
import { WrapField, WrapFieldContent, WrapGender } from 'components/Form/Styled'
import { ReactComponent as MaleIcon } from 'assets/Male.svg';
import { ReactComponent as FemaleIcon } from 'assets/Female.svg';
import { Button, Error } from 'components/Form';
import { gender } from 'keys';

/**
 * Gender (male/female selector)
 * Two icon buttons for selecting gender in forms. Uses values from `keys/gender`
 * (`gender.male` → `"MALE"`, `gender.female` → `"FEMALE"`).
 *
 * **How it works**
 * - Pass form state via `input`: `{ value, onChange }`.
 * - Clicking a button calls `onChange` with the selected gender constant.
 * - Active button is highlighted (`thirdly2`); inactive uses `thirdly4`.
 * - Validation errors render via `<Error {...props} />`.
 *
 * Used in redux-form schemas with `component: "gender"`.
 *
 * @param {Object} props
 * @param {Object} props.input - Form binding: `{ value, onChange }`.
 * @param {string} [props.input.value] - Current value: `gender.male` or `gender.female`.
 * @param {Function} props.input.onChange - Called with the selected gender constant.
 * @param {string} [props.className] - CSS class on the field wrapper.
 * @param {string} [props.gridArea] - Grid area name; combined with `arrayIndex`.
 * @param {number} [props.arrayIndex] - Index suffix for grid placement.
 * @example
 * <Gender input={{ value: genderValue, onChange: setGenderValue }} />
 * @example
 * // In form field config
 * { name: 'gender', component: 'gender' }
 */
const Gender = (props) => {
    const { gridArea, arrayIndex, className, input } = props
    const { value, onChange } = input

    const renderColor = (gender) => value === gender ? "thirdly2" : "thirdly4"

    return (
        <WrapField className={className} gridArea={`${gridArea}_${arrayIndex}`}>
            <WrapFieldContent>
                <WrapGender>
                    <Button color={renderColor(gender.male)} action={() => onChange(gender.male)}>
                        <SvgIcon component={MaleIcon} inheritViewBox />
                    </Button>
                    <Button color={renderColor(gender.female)} action={() => onChange(gender.female)}>
                        <SvgIcon component={FemaleIcon} inheritViewBox />
                    </Button>
                </WrapGender>
            </WrapFieldContent>
            <Error {...props} />
        </WrapField>
    )
}

export default Gender